import { render, staticRenderFns } from "./AccountSettingsNotification.vue?vue&type=template&id=deed05ce&"
import script from "./AccountSettingsNotification.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports